/**
 * Get Graphql Client / custom declaration of node_modules/nuxt-graphql-client/dist/runtime/composables/index.mjs
 *
 */
export const useGelosoGqlState = () => {
    const nuxtApp = useNuxtApp()
    if (!nuxtApp._gqlState) {
        throw new Error('GQL State is not available.')
    }
    return nuxtApp?._gqlState
}

export const getGelosoGqlClient = (client, state) => {
    if (!state) {
        state = useGelosoGqlState()
    }

    const clientName = client || (state.value?.default ? 'default' : Object.keys(state.value)[0])

    return state.value[clientName].instance
}
